import { z } from 'zod'

export const learnerSignInOtpSendResponseSchema = z.object({
  success: z.literal(true),
  message: z.string().min(1),
}).strict()

export type LearnerSignInOtpSendResponse = z.infer<typeof learnerSignInOtpSendResponseSchema>
